import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type Response<T> = [
    T,
    Dispatch<SetStateAction<T>>,
];

const STORAGE_PREFIX = 'tm_react_';

function usePersistedState<T>(key: string, initialState: T): Response<T> {
    const [state, setState] = useState(() => {
        try {
            const storageKey = STORAGE_PREFIX + key;
            const storageValue = localStorage.getItem(storageKey);

            if (storageValue && storageValue !== 'undefined' && storageValue !== 'null') {
                // Проверяем, что это валидный JSON
                const parsed = JSON.parse(storageValue);
                return parsed;
            }
        } catch (error) {
            // Если ошибка парсинга - игнорируем и используем initialState
            console.warn(`usePersistedState: Failed to parse localStorage key "${key}", using default value`, error);
            // Опционально: очищаем невалидные данные
            localStorage.removeItem(STORAGE_PREFIX + key);
        }
        return initialState;
    });

    useEffect(() => {
        const storageKey = STORAGE_PREFIX + key;
        localStorage.setItem(storageKey, JSON.stringify(state));
    }, [key, state]);

    return [state, setState];
}

export default usePersistedState;